<template>
  <div>
    <div class="row">
      <div :class="['col_12', {'loading_overlay': loading}]">
        <div class="card no_border">
          <div class="card-header">
            <div class="card-title">{{ title }}</div>
          </div>
          <div class="card-body pl_0 pr_0">
            <div class="row">
              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('name')}]">
                  <label>문의종류</label>
                  <input type="text" class="form_global" v-model="form.name">
                  <v-errors :errors="errorFor('name')" />
                </div>
              </div>
              <div class="col_4">
                  <div :class="['form-group', {'has_error': errorFor('status')}]">
                      <label>사용여부</label>
                      <div class="form_inline">
                          <div class="form_radio">
                              <input type="radio" id="active" value="1" v-model="form.status">
                              <label for="active">사용</label>
                          </div>
                          <div class="form_radio">
                              <input type="radio" id="inactive" value="0" v-model="form.status">
                              <label for="inactive">미사용</label>
                          </div>
                      </div>
                      <v-errors :errors="errorFor('status')" />
                  </div>
              </div>
              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('use_for')}]">
                  <label>대상</label>
                  <select v-model="form.use_for" class="form_global">
                    <option value="">대상 선택</option>
                    <option value="parent">학부모</option>
                    <option value="student">학생</option>
                  </select>
                  <v-errors :errors="errorFor('use_for')" />
                </div>
              </div>
            </div>
            <div class="d_flex_end form_action_btn">
              <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
              <button class="btn btn_blue ml_10" :disabled="loading" @click.prevent="submit">{{ $t('common.save') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: { },
  data() {
    return {
      title: '문의종류추가',
      cancelRouteName: 'inquiry_type_list',
      form: {
        use_for: '',
        name: "",
        status: 1,
      }
    }
  },
  created() {

    if (this.$route.name === 'inquiry_type_edit') {
      this.axios.get('/inquiry-types/'+this.$route.params.id)
          .then((response) => {
            let editInquiryTypeData = response.data.data;

            this.form.use_for = editInquiryTypeData.use_for
            this.form.name = editInquiryTypeData.name
            this.form.status = editInquiryTypeData.status

          })
      this.title = '문의 유형 수정';
    }
  },
  watch:{
    
  },
  methods: {
    submit() {
      this.allErrors = null;
      this.loading = true;

      if (this.$route.name === 'inquiry_type_edit') {
        this.axios.patch('/inquiry-types/'+this.$route.params.id, this.form)
            .then(() => {
              this.$router.push({name: 'inquiry_type_list'});
              this.showSuccessMsg(this.$t('common.updateSuccess'))
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors;
            })
            .finally(() => {
              this.loading = false;
            });
      } else {
        this.axios.post('/inquiry-types', this.form)
            .then(() => {
              this.$router.push({name: 'inquiry_type_list'});
              this.showSuccessMsg(this.$t('common.addSuccess'))
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors;
            })
            .finally(() => {
              this.loading = false;
            });
      }
    }
  }
}
</script>
<style scoped>
  .dp__menu{
    top: 196px;
  }
</style>
